import { Button } from "@gonoodle/gn-universe-ui";
import { stripQueryString } from "@gonoodle/gn-universe-utils";
import { useState } from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";
import { LinkIcon } from "@heroicons/react/outline";

import config from "../config";
import { useLogEvent } from "../contexts/Analytics";

const generateContentHref = (base, params = {}) => {
  let path = `${base}`;

  path += Object.keys(params).reduce((acc, key, i) => {
    const prefix = i === 0 ? `?${acc}` : `${acc}&`;
    if (params[key]) {
      return `${prefix}${key}=${encodeURIComponent(params[key])}`;
    }

    return acc;
  }, "");

  return path;
};

const ShareContentButton = ({ url, linkParams, impressionsProps }) => {
  const [clicked, setClicked] = useState(false);
  const router = useRouter();
  const link = url || stripQueryString(`${config.WEB_URL}${router.asPath}`);
  const {
    sourcePage,
    sourcePageType,
    ...analyticsProperties
  } = impressionsProps;

  useLogEvent({
    event: "Content Shared",
    properties: analyticsProperties,
    options: {
      enabled: clicked,
      referrer: {
        sourcePage,
        sourcePageType,
      },
    },
  });

  const handleButtonPress = () => {
    navigator.clipboard.writeText(generateContentHref(link, linkParams));
    setClicked(true);
  };

  return (
    <Button variant="light-outline" onPress={handleButtonPress} size="md">
      <span className="inline-flex justify-center items-center font-bold">
        {clicked ? "Copied!" : "Share"}
        <LinkIcon className="h-md ml-xs" />
      </span>
    </Button>
  );
};

ShareContentButton.propTypes = {
  url: PropTypes.string,
  linkParams: PropTypes.shape({
    sourcePage: PropTypes.string,
    sourcePageType: PropTypes.string,
    sourceName: PropTypes.string,
    sourceElement: PropTypes.string,
  }),
  impressionsProps: PropTypes.shape({
    contentType: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    sourcePage: PropTypes.string,
    sourcePageType: PropTypes.string,
  }),
};

ShareContentButton.defaultProps = {
  url: undefined,
  linkParams: undefined,
  impressionsProps: {},
};

export default ShareContentButton;
